import { __spreadArray } from "tslib";
import { cloneDate } from '@progress/kendo-date-math';
var isObject = function (value) { return value && typeof (value) === "object" && !Array.isArray(value); };
var isHtmlElement = function (element) { return element instanceof HTMLElement; };
var dateSetter = function (method) { return function (date, value) {
    var clone = cloneDate(date);
    clone[method](value);
    return clone;
}; };
/**
 * @hidden
 */
export var isPresent = function (value) { return value !== undefined && value !== null; };
/**
 * @hidden
 */
export var isDocumentAvailable = function () { return !!document; };
/**
 * @hidden
 */
export var isNumber = function (value) { return isPresent(value) && typeof (value) === "number" && !Number.isNaN(value); };
/**
 * @hidden
 */
export var parseToInt = function (value) { return parseInt(value, 10); };
/**
 * @hidden
 */
export var isParseableToInt = function (value) { return isNumber(parseToInt(value)) && /^[0-9]+$/.test(value); };
/**
 * @hidden
 */
export var clamp = function (value, min, max) { return Math.min(max, Math.max(min, value)); };
/**
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export var extend = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Object.assign.apply(Object, args);
};
/**
 * @hidden
 */
export var deepExtend = function (target) {
    var _a, _b;
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (!sources.length) {
        return target;
    }
    var source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (var key in source) {
            if (!Object.prototype.hasOwnProperty.call(source, key) ||
                key === "__proto__" ||
                key === "constructor" ||
                key === "prototype") {
                continue;
            }
            if (isHtmlElement(source[key])) {
                target[key] = source[key];
            }
            else if (isObject(source[key]) && !(source[key] instanceof Date)) {
                if (!target[key] || !isObject(target[key])) {
                    extend(target, (_a = {}, _a[key] = {}, _a));
                }
                deepExtend(target[key], source[key]);
            }
            else {
                extend(target, (_b = {}, _b[key] = source[key], _b));
            }
        }
    }
    return deepExtend.apply(void 0, __spreadArray([target], sources, false));
};
/**
 * @hidden
 */
// eslint-disable-next-line
export var noop = function () { };
/**
 * @hidden
 */
export var isFunction = function (fn) { return typeof (fn) === "function"; };
/**
 * @hidden
 */
export var cropTwoDigitYear = function (date) {
    if (!isPresent(date) || isNaN(date.getTime())) {
        return 0;
    }
    return Number(date
        .getFullYear()
        .toString()
        .slice(-2));
};
/**
 * @hidden
 */
export var setYears = dateSetter('setFullYear');
/**
 * @hidden
 */
export var millisecondDigitsInFormat = function (format) {
    var result = format && format.match(/S+(\1)/);
    return result ? result[0].length : 0;
};
/**
 * @hidden
 */
export var millisecondStepFor = function (digits) {
    return Math.pow(10, 3 - digits);
};
/**
 * @hidden
 */
export var areDatePartsEqualTo = function (date, year, month, day, hour, minutes, seconds, milliseconds) {
    if (date &&
        date.getFullYear() === year &&
        date.getMonth() === month &&
        date.getDate() === day &&
        date.getHours() === hour &&
        date.getMinutes() === minutes &&
        date.getSeconds() === seconds &&
        date.getMilliseconds() === milliseconds) {
        return true;
    }
    return false;
};
/**
 * @hidden
 */
export var isValidDate = function (value) { return isPresent(value) && value.getTime && isNumber(value.getTime()); };
/**
 * @hidden
 */
export var isIOS = function () { return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /Macintosh/i.test(navigator.userAgent)); };
